import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fullcalendar-pro',
	templateUrl:'./FullCalendarProPluginPage.html',
	styles: [],
	styleUrls:['./FullCalendarProPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarProPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_586 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>full-calendar-pro</artifactId>
</dependency>
\`\`\``;
	mdContent_587 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:full-calendar-pro:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_588 = `\`\`\`json
"@fullcalendar/resource-daygrid": "^6.1.19"
"@fullcalendar/resource-timeline": "^6.1.19"
"@fullcalendar/resource-timegrid": "^6.1.19"
"@fullcalendar/adaptive": "^6.1.19"
\`\`\``;
	mdContent_589 = `\`\`\`java
FullCalendarOptions options = new FullCalendarOptions()
    .setInitialView("resourceTimelineDay")
    .setResourceAreaHeaderContent("Resources")
    .setResources(List.of(
        new Resource().setId("r1").setTitle("Room A"),
        new Resource().setId("r2").setTitle("Room B")
    ))
    .addEvent(new Event()
        .setTitle("Meeting")
        .setResourceId("r1")
        .setStart("2026-03-24T09:00")
        .setEnd("2026-03-24T10:30"));
\`\`\``;
	mdContent_590 = `\`\`\`java
FullCalendarOptions options = new FullCalendarOptions()
    .setInitialView("resourceTimelineDay")
    .setResourceAreaHeaderContent("Resources")
    .setResources(List.of(
        new Resource().setId("r1").setTitle("Room A"),
        new Resource().setId("r2").setTitle("Room B")
    ))
    .addEvent(new Event()
        .setTitle("Booking")
        .setResourceId("r1")
        .setStart("2026-03-24T09:00")
        .setEnd("2026-03-24T12:00"));
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
